var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"hide-details":"","color":"open","input-value":_vm.value,"inset":"","label":_vm.label},on:{"change":_vm.update}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }